import React from 'react';
import { useNavigate } from 'react-router-dom';
import CssHelper from 'Services/Utils/Css/CssHelper';
import styles from './BreadcrumbItem.module.sass';

const BreadcrumbItem = ({
    children,
    path,
    size,
    weight
}: Props) => {
    const navigate = useNavigate();

    return <div className={`${styles['breadcrumb-item']} ${styles['breadcrumb-item--'+(path ? 'clickable' : 'non-clickable')]}`} onClick={() => path ? navigate(path) : ({})}>
        <div
            className={CssHelper.createCssClass(`
                ${styles['breadcrumb-item']}
                ${styles['breadcrumb-item__size--'+(size||'medium')]}
                ${styles['breadcrumb-item__weight--'+(weight||'semibold')]}
            `)}
        >{ children }</div>
    </div>;
};

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    path?: string
    size?: 'medium' | 'small' | 'xsmall'
    weight?: 'semibold' | 'normal'
}

export default BreadcrumbItem;